import { useAuth0 } from '@auth0/auth0-react';
import { Menu, Space, Icons, Card, Button, Dropdown } from '@pankod/refine-antd';
import applicationImage from 'assets/images/application1.svg';
import { OrgDeleteModal, OrgEditModal } from 'components/modal';
import { useState } from 'react';
import useOrganizationStore from 'store/useOrganizationStore';

type OrgSelectCardProps = {
  id: string;
  name: string;
};

export const OrgSelectCard: React.FC<OrgSelectCardProps> = ({ id, name }) => {
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const { organizations, currentOrganization, setCurrentOrganization } = useOrganizationStore();
  const { loginWithRedirect } = useAuth0();

  const isCurrentOrganization = currentOrganization ? currentOrganization.id === id : false;

  const handleSelect = () => {
    const redirectUri = `${window.location.origin}/apps`;
    const selectedOrganization = organizations.find((org) => org.id === id);
    if (selectedOrganization) {
      window.localStorage.clear();
      loginWithRedirect({ orgId: id, redirectUri });
      setCurrentOrganization(selectedOrganization);
    }
  };

  const moreMenu = () => (
    <Menu mode="vertical" onClick={({ domEvent }) => domEvent.stopPropagation()}>
      <Menu.Item key="edit" onClick={() => setIsEditModalOpen(true)}>
        <Space style={{ marginRight: '0.5rem' }}>
          <Icons.EditOutlined />
        </Space>
        <Space>Edit</Space>
      </Menu.Item>
      {!isCurrentOrganization && (
        <Menu.Item key="delete" onClick={() => setIsDeleteModalOpen(true)}>
          <Space style={{ marginRight: '0.5rem' }}>
            <Icons.DeleteOutlined style={{ color: '#f44336' }} />
          </Space>
          <Space style={{ color: '#f44336' }}>Delete</Space>
        </Menu.Item>
      )}
    </Menu>
  );

  return (
    <>
      <OrgEditModal
        orgId={id}
        isModalOpen={isEditModalOpen}
        closeModal={() => setIsEditModalOpen(false)}
      />
      <OrgDeleteModal
        orgId={id}
        isModalOpen={isDeleteModalOpen}
        closeModal={() => setIsDeleteModalOpen(false)}
      />

      <Card style={{ width: '250px' }}>
        <div style={{ width: '100%', marginBottom: '1.5rem' }}>
          <span>
            <img
              src={applicationImage}
              alt="Avatar"
              style={{
                width: '16px',
                display: 'inline-block',
                marginRight: '0.5rem',
                marginBottom: '3px',
              }}
            />
          </span>
          <Space style={{ fontSize: '1rem', fontWeight: 700 }}>{name}</Space>
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Button style={{ width: '80%', borderRadius: '3px' }} onClick={handleSelect}>
            Select
          </Button>
          <Dropdown overlay={moreMenu()} trigger={['click']}>
            <Icons.MoreOutlined onClick={(e) => e.stopPropagation()} style={{ fontSize: 24 }} />
          </Dropdown>
        </div>
      </Card>
    </>
  );
};
